import { AloftArea, AloftPrice, schPositiveInt } from '@aloft/toolkit-shared';

import { z } from 'zod';

import { VIEW_MODES } from './consts.ts';

export type ViewMode = keyof typeof VIEW_MODES;

export const schFormPositiveInt = z
  .string()
  .transform((v) => Number(v))
  .pipe(schPositiveInt);

const schUndefinedPassthrough = z.literal('').pipe(z.undefined());

export const schArea = z
  .string()
  .default('')
  .transform((str) => str.replace(/,/g, ''))
  .pipe(z.coerce.number().min(0))
  .transform((val) => AloftArea.fromNumber(val, 'sqft').toJSON());

export const schAreaWithUnit = z
  .object({
    area: z
      .string()
      .default('')
      .transform((str) => str.replace(/,/g, ''))
      .pipe(z.coerce.number().min(0)),
    unit: z.enum(['sqft', 'acre']),
  })
  .transform(({ area, unit }) => AloftArea.fromNumber(area, unit).toJSON());

export const schRequiredArea = z
  .string()
  .transform((str) => str.replace(/,/g, ''))
  .pipe(z.coerce.number().gt(0))
  .transform((val) => AloftArea.fromNumber(val, 'sqft').toJSON());

export const schPrice = z
  .string()
  .default('')
  .transform((str) => str.replace(/[,$]/g, ''))
  .pipe(z.coerce.number().min(0))
  .transform((val) => AloftPrice.fromDollarLike(val).toJSON())
  .or(schUndefinedPassthrough);

export const schCraftsmanSFRQualityClasses = z
  .string()
  .pipe(z.coerce.number().min(1).max(6).multipleOf(0.1))
  .transform((val) => val);
